export default __webpack_public_path__ + "static/media/request-rejected.7f927d61.svg";